<template>
  <b-modal id="business-details-new" size="lg" centered hide-header hide-footer>
    <div class="align-middle">
      <b-row>
        <b-col class="position-static mx-2">
          <h1 class="mb-4 mt-md-4">
            Business Registration
          </h1>
          <b-form class="row">
            <b-col md="8" class="mb-3" v-if="this.business.type !== 'SA Registered Company (Private Company – Pty Limited)' && this.business.type !== 'SA Registered Closed Corporation (CC)'">
              <maz-select v-model="business.country" placeholder="Country of Establishment" search search-placeholder="Search Country" clearable required :success="business.country !== ''" :options="countries"></maz-select>
              <small class="ml-2 form-text text-muted">As per official documentation</small>
            </b-col>
            <b-col md="8" class="mb-3">
              <maz-input v-model="business.name" placeholder="Registered Business Name" required :error="business.name === ''" :success="business.name && business.name !== '' && business.name.length >= 2"></maz-input>
              <small class="ml-2 form-text text-danger" v-if="business.name === ''">Registered Business Name is required.</small>
              <small class="ml-2 form-text text-muted" v-else>As per official documentation</small>
            </b-col>
            <b-col md="8" class="mb-3" v-if="business.type !== 'Sole Proprietor'">
              <maz-input v-model="business.reg_number" placeholder="Registered Number" required :error="business.reg_number === ''" :success="business.reg_number && business.reg_number !== '' && business.reg_number.length >= 2"></maz-input>
              <small class="ml-2 form-text text-danger" v-if="business.name === ''">Registered Number is required.</small>
              <small class="ml-2 form-text text-muted" v-else>As per official documentation</small>
            </b-col>
            <b-col md="8" class="mb-5" v-if="false">
              <maz-input v-model="business.email" placeholder="Business Email Address" :error="(business.email !== null && business.email !== '' && !isEmail)" :success="Boolean(business.email) && business.email !== '' && isEmail"></maz-input>
            </b-col>
            <b-form-group class="col-12">
              <template v-slot:label>
                Your Relationship to Business
              </template>
              <div class="row pl-3">
                <b-form-checkbox v-model="business.relationship" value="Shareholder" class="col-md-5">
                  Shareholder
                </b-form-checkbox>
                <b-form-checkbox v-model="business.relationship" value="Director" class="col-md-5">
                  Director
                </b-form-checkbox>
                <b-form-checkbox v-model="business.relationship" value="CEO" class="col-md-5">
                  Chief Executive Officer
                </b-form-checkbox>
                <b-form-checkbox v-model="business.relationship" value="Authorised Representative" class="col-md-5">
                  Authorised Representative
                </b-form-checkbox>
              </div>
            </b-form-group>
            <b-col md="4" offset-md="8" align-self="end">
              <loading-button :replace="saving === true">
                <b-button class="mb-3" variant="custom" pill block :disabled="!canGoNext" @click="next()">Next</b-button>
              </loading-button>
            </b-col>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { verificationService } from '@/services/verification.service'
import { mapActions, mapState } from 'vuex'
import { validators } from '@/validators-sa'

export default {
  data () {
    return {
      saving: false,
      business: {
        status: null,
        type: null,
        shareholders: null,
        nationality: null,
        directors: null,
        country: '',
        name: null,
        reg_number: null,
        email: null,
        relationship: []
      },
      countries: []
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      company: state => state.company,
      countriesStore: state => state.country.countries,
      registration: state => state.registration
    }),
    canGoNext () {
      if (this.business.country && this.business.name && this.business.name.length >= 2) {
        if (this.business.relationship && this.business.relationship.length >= 1) {
          if (this.business.type === 'Sole Proprietor') {
            if (this.business.email && this.business.email !== '') {
              if (this.isEmail) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          } else {
            if (this.business.reg_number && this.business.reg_number.length >= 2) {
              if (this.business.email && this.business.email !== '') {
                if (this.isEmail) {
                  return true
                } else {
                  return false
                }
              } else {
                return true
              }
            } else {
              return false
            }
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isEmail () {
      return validators.email(this.business.email)
    }
  },
  created () {
    this.countriesStore.forEach(country => {
      this.countries.push({ value: country.code, label: country.name })
    })
  },
  mounted () {
    this.business = this.registration.business
  },
  methods: {
    ...mapActions('alert', {
      setSuccess: 'success',
      setError: 'error',
      clear: 'clear'
    }),
    ...mapActions('company', {
      create: 'create'
    }),
    ...mapActions('registration', {
      update: 'updateState'
    }),
    next: async function () {
      if (this.canGoNext) {
        try {
          this.saving = true
          const _response = await verificationService.checkCompany(this.business.name, this.business.reg_number, this.business.country)

          if (!_response) {
            this.update({
              state: 'business',
              value: this.business
            })
            const _payload = {}
            _payload.orderid = this.registration.payment.orderid
            _payload.company = this.business.name
            _payload.company_reg = this.business.reg_number
            _payload.company_country = this.business.country
            _payload.company_relationship = this.business.relationship
            _payload.company_status = this.business.status
            _payload.company_type = this.business.type
            _payload.company_email = this.business.email
            _payload.company_answers = {
              shareholders: this.business.shareholders,
              nationality: this.business.nationality,
              directors: this.business.directors
            }
            if (this.registration.payment.save_details) {
              _payload.card = {
                details: this.registration.payment.card,
                name: this.registration.payment.name
              }
            }

            this.create(_payload)
          } else {
            this.saving = false
            this.clear()
            this.setError('This company is already registered with Truzo. Please contact ' + this.business.name + ' Truzo profile administrator to create a user record for you.')
          }
        } catch (error) {
          this.saving = false
          console.log(error)
          this.clear()
          this.setError('There was an error verifying company details. Please, double check your internet connection and try again.')
        }
      } else {
        this.saving = false
        this.clear()
        this.setError('You have to complete all the fields here before moving to the next section.')
      }
    }
  },
  watch: {
    'business.type': function (value) {
      if (value === 'SA Registered Company (Private Company – Pty Limited)' || value === 'SA Registered Closed Corporation (CC)') {
        this.business.country = 'ZA'
      }
    }
  }
}
</script>
